<template>
  <header id="header">
    <div class="header-top">
      <div class="w1290">
        <!-- <el-badge :value="199" class="item" type="primary"> -->
        <div
          style="display: flex; align-items: center"
          class="cursor"
          @click="$router.push({ path: '/shopingCart' })"
        >
          <img
            src="../../assets/gouwuchekong.png"
            class="cursor"
            alt=""
            width="20px"
          />
          <span style="margin-left: 6px; color: #ae60fc">购物车</span>
        </div>
        <!-- </el-badge> -->

        <span>咨询热线：159-7748-6076</span>
        <a class="cursor" href="https://agent.sanmaoyk.com" target="_blank"
          >经销商登录</a
        >
      </div>
    </div>
    <div class="header-c w1290">
      <div>
        <img
          src="../../assets/logo.png"
          class="logo cursor"
          alt=""
          @click="$router.push({ path: '/' })"
        />

        <nav class="header-nav">
          <a
            class="cursor"
            :class="PageIndex == 1 ? 'active' : ''"
            @click="$router.push({ path: '/' })"
            >首页</a
          >
          <a
            class="cursor"
            :class="PageIndex == 2 ? 'active' : ''"
            @click="$router.push({ path: '/courseList' })"
            >课程</a
          >
          <!-- <a class="cursor" :class="PageIndex == 3 ? 'active' : ''" href="https://www.sanmaoyk.com/download/"
            target="_blank">题库</a> -->
          <a
            class="cursor"
            :class="PageIndex == 8 ? 'active' : ''"
            href="https://www.sanmaoyk.com/simulationExamination/"
            target="_blank"
            >模拟机考</a
          >
          <!-- <a class="cursor" :class="PageIndex == 8 ? 'active' : ''" href="https://wendu.changyangdt.com/jikao/"
            target="_blank">模拟机考</a> -->
          <a
            class="cursor"
            :class="PageIndex == 4 ? 'active' : ''"
            @click="$router.push({ path: '/bookMall' })"
            >教辅资料</a
          >
          <a
            class="cursor"
            :class="PageIndex == 5 ? 'active' : ''"
            @click="$router.push({ path: '/testPreparationInformation' })"
            >备考资讯</a
          >
          <a
            class="cursor"
            :class="PageIndex == 6 ? 'active' : ''"
            @click="$router.push({ path: '/teachers' })"
            >师资</a
          >
          <!-- <a class="cursor" :class="PageIndex == 7 ? 'active' : ''" @click="$router.push({ path: '/aboutUs' })">关于我们</a> -->
        </nav>
      </div>
      <div>
        <div class="learningCenter">
          <a class="cursor" @click="$router.push({ path: '/learningCenter' })">
            <img src="../../assets/learningCenter.png" alt="" />
            <div>学习中心</div>
          </a>
        </div>
        <div class="loginBtn">
          <el-dropdown @command="command" size="medium">
            <!-- <span class="el-dropdown-link">
              下拉菜单<i class="el-icon-arrow-down el-icon--right"></i>
            </span> -->
            <a @click="login" class="el-dropdown-link cursor">
              <img src="../../assets/gerenzhongxin.png" alt="" />
              <div v-if="userInfo">{{ userInfo.stuName }}</div>
              <!-- <div v-if="userInfo">文都用户</div> -->
              <div v-else>登录/注册</div>
            </a>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="userInfo" command="myOrder"
                >我的订单</el-dropdown-item
              >
              <el-dropdown-item v-if="userInfo" command="logout" divided
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: ["PageIndex"],
  data() {
    return {
      userInfo: { stuName: "" },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.userInfo = window.localStorage.getItem("userInfo")
        ? JSON.parse(window.localStorage.getItem("userInfo"))
        : "";
    });
  },
  methods: {
    login() {
      if (!this.userInfo) {
        this.$router.push("/login");
      }
    },
    command(command) {
      if (command == "logout") {
        window.localStorage.clear();
        this.$router.push("/login");
      } else {
        this.$router.push("/myOrder");
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
/deep/ .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #ae60fc !important;
  color: #ffffff !important;
}
#header {
  width: 100%;
  background-color: #ffffff;

  .header-top {
    width: 100%;
    background-color: #eef0f3;

    > div {
      height: 40px;
      background: #eef0f3;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      span,
      a {
        display: block;
        font-size: 14px;
        font-family: Microsoft YaHei;
        color: #3d3f46;
        margin-left: 30px;
      }
    }
  }

  .header-c {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    position: -webkit-sticky;
    top: 0;

    > div {
      display: flex;
      height: 90px;
      align-items: center;
    }

    .logo {
      width: 220px;
      height: 59px;
    }

    .header-nav {
      display: flex;
      align-items: center;

      > a:hover {
        color: #ae60fc;
        transform: translate(0, -2px);
      }

      > a {
        display: block;
        height: 90px;
        line-height: 90px;
        margin-left: 40px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        color: #333333;
        transition: transform 0.3s;
      }

      .active {
        color: #ae60fc;
        border-bottom: 3px solid #ae60fc;
      }
    }

    .learningCenter {
      a {
        width: 150px;
        height: 40px;
        border: 1px solid #fa642c;
        border-radius: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      img {
        width: 26px;
        height: 22px;
        margin-right: 9px;
      }

      div {
        font-size: 16px;
        font-family: Microsoft YaHei;
        color: #fa642c;
      }
    }

    .loginBtn {
      margin-left: 20px;
      height: 40px;

      a {
        width: 150px;
        height: 40px;
        border: 1px solid #ae60fc;
        border-radius: 42px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
      }

      img {
        width: 22px;
        height: 22px;
        margin-right: 7px;
      }

      div {
        font-size: 16px;
        font-family: Microsoft YaHei;
        color: #ae60fc;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue